import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserInfo } from 'hooks/useUserInfo';
import { calculateDynamicConfig, getCurrentAppType } from 'utils/dynamicConfig';

const DefaultRoute: React.FC = () => {
  const appType = getCurrentAppType();
  const targetPath = appType.includes('ops') ? '/ops-tools' : '/order-create';
  
  return <Navigate to={targetPath} replace />;
};

export default DefaultRoute; 